import { combineReducers, configureStore, createStore } from '@reduxjs/toolkit';
import { useDispatch } from "react-redux";
import authReducer from '../features/auth/authSlice';
import usersReducer from '../features/setup/user-management/usersSlice';
import indicatorsMappingReducer from '../features/setup/indicator-mapping/IndicatorsMappingSlice';
import reportsMinistryMappingReducer from '../features/setup/reports-mapping/reportsMappingSlice';
import languageSlice from '../features/language/languageSlice';
import masterDataSlice from '../features/master/masterSlice';
import loadingSlice from './loadingSlice';
import IndicatorReducer from '../features/data-collection/indicatorsSlice';
import layoutDataSlice from '../layouts/setup/layoutSlice';
import ReportsReducer from '../features/reports/reportIndicatorsSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';
import filtersReducer from '../features/data-collection/indicators/components/slice/filterSlice';
// import rootReducer from './reducers';

const persistConfig = {
    key: 'root',
    storage, // Storage engine (localStorage here)
    whitelist: ['auth'], // Reducers to persist
    blacklist: ['loading', 'users', 'indicatorsMapping', 'reportsMinistryMapping', 'language', 'masterData', 'indicatorsData', 'layoutData', 'reportsData'], // Reducers to exclude from persistence
};

const rootReducer = combineReducers({
    auth: authReducer,
    users: usersReducer,
    indicatorsMapping: indicatorsMappingReducer,
    reportsMinistryMapping: reportsMinistryMappingReducer,
    language: languageSlice,
    masterData: masterDataSlice,
    loading: loadingSlice,
    indicatorsData: IndicatorReducer,
    layoutData: layoutDataSlice,
    reportsData: ReportsReducer,
    filters: filtersReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer, // Use the persisted reducer
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // Disable serializable checks for redux-persist
        }),
});

// Persistor for rehydration
export const persistor = persistStore(store);


// dispatch does not take types for thunks into account and thus the return type is typed incorrectly. Please use the actual Dispatch type from the store as decsribed in the documentation. Ref: https://stackoverflow.com/questions/63811401/property-then-does-not-exist-on-type-asyncthunkaction-redux-toolkit
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()

export type RootState = ReturnType<typeof store.getState>;
export default store;